module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/sv-card-drag.6d5621c2be0e8876ce54.gif";